// CashTransactionDialog.vue
export const defaultCashTransaction = {
    id: null,
    ctnxNo: null,
    place: null,
    customerId: null,
    customerName: null,
    particular: null,
    cashCategoryId: null,
    io: 1,
    book: 1,
    mode: null,
    reference: null,
    tnxFor: 0,
    cashAccId: null,
    cashAccName: null,
    toCashAccId: null,
    toCashAccName: null,
    bankTransactionNo: null,
    amount: 0,
    prCurrency: null,
    forCurrency: 2,
    note: null,
    usdRate: 0,
    employeeId: null,
    employeeName: null,
    branchName: null,
    branchCode: null,
    date: null,
    isDeleted: 0
}

// CustomerDialog.vue
export const defaultCustomer = {
    id: null,
    username: null,
    name: null,
    phone: null,
    address: null,
    remark: null,
    status: 1
}

export const defaultCustomerListQuery = {
    pageNum: 1,
    pageSize: 10,
    keyword: null
}

// EmployeeDialog.vue
export const defaultEmployee = {
    id: null,
    name: null,
    username: null,
    email: null,
    remark: null,
    status: 1
}

export const defaultEmployeeListQuery = {
    pageNum: 1,
    pageSize: 10,
    keyword: null
}

// ItemTransactionDialog.vue
export const defaultItemTransaction = {
    id: null,
    itnxNo: null,
    place: null,
    customerId: null,
    reference: null,
    subReferences: null,
    customerName: "",
    io: 1,
    tnxFor: 0,
    of: 1,
    sku: null,
    description: null,
    note: "",
    categoryId: null,
    parentCategoryId: null,
    attributeCategoryId: null,
    categoryName: "",
    quality: "",
    qty: 1,
    qtyUnit: 1,
    wt: 0,
    wtUnit: 3,
    wtStr: "",
    employeeId: null,
    employeeName: "",
    inventoryType: null,
}

export const defaultItemTransactionRawWt = {
    totalK: null,
    totalP: null,
    totalY: null,
    totalG: null,
}

// PandyTransferItemDialog.vue
export const defaultPandyTransferItem = {
    id: null,
    pandyTransferType: 1,
    pandyTransferNo: null,
    ptItemNo: null,
    customerSmithOwnerId: null,
    customerSmithOwnerName: "",
    place: null,
    of: 1,
    sku: null,
    inventoryType: 1,
    refNo: null,
    slotCode: null,
    pic: null,
    qty: 1,
    qtyUnit: 1,
    wt: 0.0,
    wtUnit: 1,
    wtStr: "",
    wtLoss: "",
    wtGem: "",
    wtNet: "",
    categoryId: null,
    parentCategoryId: null,
    categoryName: "",
    quality: "",
    note: "",
    isReturnedReceived: 0,
    returnedReceivedAt: null,
    returnedReceivedPlace: null,
    returnedReceivedBranchName: null,
    returnedReceivedSlotCode: null,
    returnedCustomerSmithId: null,
    returnedCustomerSmithName: "",
    receivedEmployeeId: null,
    receivedEmployeeName: "",
    componentList: [],
    sort: 100,
    crudStatus: 2,
    createdAt: null,
    lastUpdate: null,
    employeeId: null,
    employeeName: ""
}

export const defaultPandyTransferItemRawWt = {
    totalK: null,
    totalP: null,
    totalY: null,
    totalG: null,
}

// PandyTransferItemRecRetDialog.vue
export const defaultPandyTransferItemRecRet = {
    id: null,
    pandyTransferType: 1,
    pandyTransferNo: null,
    ptItemNo: null,
    customerSmithOwnerId: null,
    customerSmithOwnerName: "",
    place: null,
    of: 1,
    inventoryType: 1,
    refNo: null,
    slotCode: null,
    sku: null,
    pic: null,
    qty: 1,
    qtyUnit: 1,
    wt: 0.0,
    wtUnit: 1,
    wtStr: "",
    wtLoss: "",
    wtGem: "",
    wtNet: "",
    categoryId: null,
    parentCategoryId: null,
    categoryName: "",
    quality: "",
    note: "",
    isReturnedReceived: 0,
    returnedReceivedAt: null,
    returnedReceivedPlace: null,
    returnedReceivedSlotCode: null,
    returnedCustomerSmithId: null,
    returnedCustomerSmithName: "",
    receivedEmployeeId: null,
    receivedEmployeeName: "",
    returnedReceivedNote: null,
    componentList: [],
    sort: 100,
    crudStatus: 2,
    createdAt: null,
    lastUpdate: null,
    employeeId: null,
    employeeName: ""
}

// SkuDialog.vue
export const defaultSku = {
    email: null,
    icon: null,
    id: null,
    name: null,
    password: null,
    remark: null,
    status: 1,
    username: null
}

// SmithDialog.vue
export const defaultSmith = {
    email: null,
    icon: null,
    id: null,
    name: null,
    nameCode: null,
    password: null,
    phone: null,
    address: null,
    remark: null,
    status: 1,
    username: null,
    countIndex: 0,
}

// TrackRecordDialog.vue
export const defaultTrackRecord = {
    id: null,
    slotId: null,
    displayId: null,
    code: null,
    productId: null,
    slotCode: null,
    of: null,
    sku: null,
    categoryName: null,
    name: null,
    recordNote: null,
    inDate: null,
    outDate: null,
    place: null,
    inItnx: null,
    outItnx: null,
    branchCode: null,
    skuPlace: null,
    employeeId: null,
    employeeName: "",
    inventoryType: null,
}

// Upload/singleUpload.vue
export const defaultUploadParam = {
    objectName: ''
}

// VendorDialog.vue
export const defaultVendor = {
    email: null,
    icon: null,
    id: null,
    name: null,
    password: null,
    phone: null,
    address: null,
    remark: null,
    status: 1,
    username: null
}
